import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageService } from './message.service';
import { PersonService } from './person.service';
import { SprintService } from './sprint.service';
import { ProjectService } from './project.service';
import { UserstoryService } from './userstory.service';
import { SettingsService } from './settings.service';
import { SynchronizationService } from './synchronization.service';
import { CommunicationService } from './communication.service';
import { InteractionService } from './interaction.service';
import { GalleryService } from './gallery.service';
import { RatingService } from './rating.service';
import { ScrumUtilsService } from './scrum-utils.service';
import { DefinitionOfDoneService } from './definition-of-done.service';
import { WhiteboardIOService } from './whiteboard-io.service';
import { TaskboardSynchroHelper } from '../actionviews/taskboard-view/taskboard-synchro-helper';
import { HTMLElementPositioningHelper } from '../util/htmlelement-positioning-helper';
import { MockVideoHelper } from '../components/widgets/vtr-widget/vtr-widget-mock-video-helper';
import { MpcboardService } from './mpcboard.service';
import { StickerService } from './sticker.service';
import { ProgramService } from './program.service';
import { ProgramIncrementService } from './programIncrement.service';
import { MPCSprintBoardSyncroHelper } from '../components/mpc-board/mpc-board-sprint/mpc-board-sprint-syncro-helper';
import { IssuecardHelper } from '../components/issuecard/issuecard.helper';
import { Sprintplanning2SynchroHelper } from '../actionviews/sprintplanning2-view/sprintplanning2-synchro-helper';
import { DependencyDrawingService } from './dependency-drawing.service';
import { DependencyEditmodeService } from './dependency-editmode.service';
import { ProductBacklogSynchroHelper } from '../components/product-backlog/product-backlog-synchro-helper';
import { SprintcardHelper } from '../components/sprintcard/sprintcard.helper';
import { ReleaseplanningSynchroHelper } from '../actionviews/release-planning-view/release-planning-synchro-helper';
import { ActiveBoardService } from './active-board.service';
import { ToolbarSettingsService } from './toolbar-settings.service';
import { OAuth2Service} from './o-auth2.service';
import { OnlineuserService } from './onlineuser.service';
import {ErrorMessageService} from './errorMessage.service';
import { ChannelService } from './channel.service';
import { CopilotService } from './copilot.service';

@NgModule({
  imports: [
  CommonModule
  ],
  providers: [
  MessageService,
  MpcboardService,
  ActiveBoardService,
  PersonService,
  ProjectService,
  RatingService,
  SprintService,
  UserstoryService,
  StickerService,
  ScrumUtilsService,
  SettingsService,
  SynchronizationService,
  CommunicationService,
  InteractionService,
  GalleryService,
  WhiteboardIOService,
  DefinitionOfDoneService,
  TaskboardSynchroHelper,
  Sprintplanning2SynchroHelper,
  ReleaseplanningSynchroHelper,
  ProductBacklogSynchroHelper,
  MockVideoHelper,
  HTMLElementPositioningHelper,
  IssuecardHelper,
  SprintcardHelper,
  ProgramService,
  ProgramIncrementService,
  MPCSprintBoardSyncroHelper,
  DependencyDrawingService,
  DependencyEditmodeService,
  ToolbarSettingsService,
  OAuth2Service,
  OnlineuserService,
  ErrorMessageService,
  ChannelService,
  ErrorMessageService,
  CopilotService,
  ],
  declarations: []
  })
/**
 * This is the module for the services
 */
export class ServicesModule {
}
